<template>
  <ul :class="!isChild ? 'global-nav__list' : 'global-subnav'">
    <li
      class="global-nav__item"
      :class="[hasChildren(item) ? 'has__sub close' : '', (item.icon || item.image) ? 'icon' : 'noIcon']"
      v-for="(item, index) in filterNav"
      :key="index"
    >
      <p class="js-btnToggleSubnav" v-if="hasChildren(item)" @click="toggleSubnav">
        <i :class="item.icon" v-if="item.icon"></i>
        <img :src="item.image" v-if="item.image">
        {{item.name}}
      </p>
      <span v-else>
        <a :href="item.url" target="_blank" v-if="item.external">
          <i :class="item.icon" v-if="item.icon"></i>
          <img :src="item.image" v-if="item.image">
          {{item.name}}
        </a>
        <nuxt-link :to="item.url" v-else>
          <i :class="item.icon" v-if="item.icon"></i>
          <img :src="item.image" v-if="item.image">
            {{item.name}}
        </nuxt-link>
      </span>
      <f-menu v-if="hasChildren(item)"
              :nav-items="filterChildren(item.children)"
              :is-child="true"
      />
    </li>
  </ul>
</template>

<script>
import {mapGetters} from 'vuex';

export default {
  name: 'f-menu',
  props: {
    navItems: {
      type: Array,
      required: true,
      default: () => []
    },
    isChild: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapGetters({
      isHasRoleApplication: 'frontend/auth/isHasRoleApplication',
    }),
    filterNav() {
      return this.navItems.filter(nav => {
        return this.canAccess(nav);
      });
    }
  },
  methods: {
    toggleSubnav(e) {
      const parent = e.target.parentElement.parentElement;
      const navs = parent.querySelectorAll('.has__sub');
      navs.forEach(nav => {
        if (e.target.parentNode === nav) {
          return
        }

        nav.classList.add('close');
      });
      e.target.parentNode.classList.toggle('close');
    },
    canAccess(nav) {
      if (nav.can) {
        if (Array.isArray(nav.can)) {
          if (nav.can.includes('proposal_view')) {
            return this.$hasPermission('accept_from_ls') && this.$planHasPermission('proposal_view')
          }
          if (nav.can.includes('accept_from_ls')) {
            if (!this.$hasPermission('accept_from_ls') && !this.$planHasPermission('crud_manual')) {
              return false;
            }
          }
          let redirectPathDefault = this.$redirectPathDefault();
          if (nav.can.includes('role_application') && redirectPathDefault.path == '/dashboard') {
            return true;
          } 
          return nav.can.some(role => this.$planHasPermission(role))
        } else {
          const hasRole = this.$planHasPermission(nav.can);
          if (!hasRole) {
            return false;
          }
        }
      }

      if (nav.role == 'is_role_application' && !this.isHasRoleApplication) {
         return false;
      }

      if (nav.role == 'is_company_normal' && this.isHasRoleApplication) {
         return false;
      }

      if (nav.middleware) {
        let result = Array.isArray(nav.middleware)
          ? nav.middleware.some(permission => this.$hasPermission(permission))
          : this.$hasPermission(nav.middleware);
        
        if (result && nav.cannot === 'manage_application_setting') {
          return !this.isHasRoleApplication && nav.cannot;
        } else {
          return result;
        }
      } else {
        return true;
      }
    },
    filterChildren(children) {
      return children.filter(item => this.canAccess(item))
    },
    hasChildren(item) {
      return item.children && item.children.length > 0;
    }
  }
}
</script>
